<template>

  <DashboardLayout :menu-items="dashboardRoutesBaseOnAccess()">


    <div class="text-dashboard  w-100 h-auto">

      <m-update-site-message-1/>

      <b-tabs v-if="isAdmin" pills align="center" class="text-center dashboard-access-button">
        <b-tab class="my-2" title="دسترسی سریع">

          <div class="container-fluid">
            <div class="row">
              <dashboard-mobile-profile class="col-lg-12 col-md-12 p-0"/>

            </div>

            <div class="row mt-n5">
              <div class="col-lg-3 col-md-6 col-6 ">
                <div class="mt-3 ">
                  <router-link class="text-decoration-none text-gray " :to="{name:'Profile'}">

                    <b-card class="text-center dash-rounded-normal p-0  dash-home-card">
                      <b-card-title>
                        <img class="img-fluid col-lg-6 " src="../../../../public/profile2.webp">
                      </b-card-title>
                      <b-card-text class="text-size-card">
                        پروفایل
                      </b-card-text>
                    </b-card>
                  </router-link>
                </div>
              </div>
              <div class="col-lg-3 col-6">
                <div class="mt-3 ">
                  <router-link class="text-decoration-none text-gray" :to="{name:'Home'}">

                    <b-card class="text-center dash-rounded-normal p-0  dash-home-card ">
                      <b-card-title>
                        <img class="img-fluid col-lg-6 " src="../../../../public/back.webp">
                      </b-card-title>
                      <b-card-text>
                        بازگشت به سایت
                      </b-card-text>
                    </b-card>
                  </router-link>
                </div>
              </div>

              <div class="col-lg-3 col-6">
                <div class="mt-3 ">
                  <router-link class="text-decoration-none text-gray" :to="{name: 'UserChats'}">

                    <b-card class="text-center dash-rounded-normal p-0  dash-home-card ">
                      <b-card-title>
                        <img class="img-fluid col-lg-6 " src="../../../../public/chat.webp">
                      </b-card-title>
                      <b-card-text>
                        چت های من
                      </b-card-text>
                    </b-card>
                  </router-link>
                </div>
              </div>

              <div class="col-lg-3 col-6 ">
                <div class="mt-3 ">
                  <router-link class="text-decoration-none text-gray"
                               :to="{name:'WishListUser',params:{user:profile.id}}">

                    <b-card class="text-center dash-rounded-normal p-0  dash-home-card ">
                      <b-card-title>
                        <img class="img-fluid col-lg-6 " src="../../../../public/fav.webp">
                      </b-card-title>
                      <b-card-text>
                        لیست موردعلاقه ها
                      </b-card-text>
                    </b-card>
                  </router-link>
                </div>
              </div>


              <div class="col-lg-6 col-12 "
                   v-if="findAttributeOnSiteInfo('show_users_orders_in_main_dashboard')[0] == 1">
                <div class="mt-3 ">
                  <router-link class="text-decoration-none" :to="{name:'UserOrders'}">
                    <My0rders class="col-12 dash-rounded-normal dash-home-card"/>
                  </router-link>
                </div>

              </div>

              <div class="col-lg-6 col-12 "
                   v-if="findAttributeOnSiteInfo('show_users_orders_in_main_dashboard')[0] == 1">
                <div class="mt-3 ">
                  <router-link class="text-decoration-none" :to="{name:'mycourse'}">
                    <MyCourse class="col-12 dash-rounded-normal dash-home-card"/>
                  </router-link>
                </div>

              </div>


            </div>
          </div>

        </b-tab>
        <b-tab class="my-2" title="مدیریت" active>

          <div class="col-12 p-0">
            <div class="row">
              <div class="col-lg-12">
                <dashboard-widget1/>
              </div>


            </div>
          </div>

        </b-tab>
      </b-tabs>


      <div class="" v-else>
        <div class="container-fluid">
          <div class="row">
            <dashboard-mobile-profile class="col-lg-12 col-md-12 "/>

          </div>

          <div class="row mt-n5">
            <div class="col-lg-3 col-md-6 col-6 ">
              <div class="mt-3 ">
                <router-link class="text-decoration-none text-gray " :to="{name:'Profile'}">

                  <b-card class="text-center dash-rounded-normal p-0  dash-home-card">
                    <b-card-title>
                      <img class="img-fluid col-lg-6 " src="../../../../public/profile2.webp">
                    </b-card-title>
                    <b-card-text class="text-size-card">
                      پروفایل
                    </b-card-text>
                  </b-card>
                </router-link>
              </div>
            </div>
            <div class="col-lg-3 col-6">
              <div class="mt-3 ">
                <router-link class="text-decoration-none text-gray" :to="{name:'Home'}">

                  <b-card class="text-center dash-rounded-normal p-0  dash-home-card ">
                    <b-card-title>
                      <img class="img-fluid col-lg-6 " src="../../../../public/back.webp">
                    </b-card-title>
                    <b-card-text>
                      بازگشت به سایت
                    </b-card-text>
                  </b-card>
                </router-link>
              </div>
            </div>

            <div class="col-lg-3 col-6">
              <div class="mt-3 ">
                <router-link class="text-decoration-none text-gray" :to="{name: 'UserChats'}">

                  <b-card class="text-center dash-rounded-normal p-0  dash-home-card ">
                    <b-card-title>
                      <img class="img-fluid col-lg-6 " src="../../../../public/chat.webp">
                    </b-card-title>
                    <b-card-text>
                      چت های من
                    </b-card-text>
                  </b-card>
                </router-link>
              </div>
            </div>

            <div class="col-lg-3 col-6 ">
              <div class="mt-3 ">
                <router-link class="text-decoration-none text-gray"
                             :to="{name:'WishListUser',params:{user:profile.id}}">

                  <b-card class="text-center dash-rounded-normal p-0  dash-home-card ">
                    <b-card-title>
                      <img class="img-fluid col-lg-6 " src="../../../../public/fav.webp">
                    </b-card-title>
                    <b-card-text>
                      لیست موردعلاقه ها
                    </b-card-text>
                  </b-card>
                </router-link>
              </div>
            </div>


            <div class="col-lg-6 col-12 "
                 v-if="findAttributeOnSiteInfo('show_users_orders_in_main_dashboard')[0] == 1">
              <div class="mt-3 ">
                <router-link class="text-decoration-none" :to="{name:'UserOrders'}">
                  <My0rders class="col-12 dash-rounded-normal dash-home-card"/>
                </router-link>
              </div>

            </div>

            <div class="col-lg-6 col-12 "
                 v-if="findAttributeOnSiteInfo('show_users_orders_in_main_dashboard')[0] == 1">
              <div class="mt-3 ">
                <router-link class="text-decoration-none" :to="{name:'mycourse'}">
                  <MyCourse class="col-12 dash-rounded-normal dash-home-card"/>
                </router-link>
              </div>

            </div>


          </div>
        </div>
      </div>

    </div>


  </DashboardLayout>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {dashboardMenu, dashboardRoutesBaseOnAccess} from '../../routes/DashboardRoutes'
import DashboardLayout from '../../components/dashboard/Layout'
import Orders from '../dashboard/orders'
import UserCourse from "../../components/dashboard/Course/UserCourse";
import DashboardMobileProfile from "../../components/dashboard/DashboardMobileProfile";
import My0rders from "@/plugin/views/dashboard/MyOrders.vue";
import MyCourse from "@/plugin/components/dashboard/Course/MyCourse.vue";
import MenuUserWidget from "@/plugin/components/dashboard/DashboardMenu/MenuUserWidget.vue";
import SwitchAdminToUser from "@/plugin/components/dashboard/DashboardMenu/SwitchAdminToUser.vue";
import DashboardWidget1 from "@/plugin/components/dashboard/DashboardWidget/DashboardWidget1.vue";
import DashboardSlider1 from "@/plugin/components/dashboard/DashboardSlider/DashboardSlider1.vue";

export default {
  name: "Dashboard",
  components: {
    DashboardSlider1,
    DashboardWidget1,
    SwitchAdminToUser,
    MenuUserWidget, MyCourse, My0rders, DashboardLayout, Orders, UserCourse, DashboardMobileProfile
  },
  data() {
    return {
      dashboardMenu,
    }
  },
  computed: {
    ...mapGetters({
      profile: "User/getProfile",
      isAdmin: "User/isAdmin",
    })
  },
  methods: {
    dashboardRoutesBaseOnAccess,
    ...mapActions({
      logout: "Authentication/logout",
    }),
  }

};
</script>

<style scoped>
.text-dashboard {
  width: 95%;
  height: auto;
  margin: auto;
  border-radius: 5px;
  padding: 10px;
}

.text-dashboard {
  width: 95%;
  height: auto;
  margin: auto;
  border-radius: 5px;
}

.dash-home-card {
  box-shadow: rgba(179, 179, 179, 0.35) 0px 2px 2px;
  border: 1px solid #c8c8c8;
  transition: all 0.3s ease-in-out;
  min-height: 140px;
}


.dash-home-card:hover {
  box-shadow: rgba(156, 156, 156, 0.35) 0px 6px 5px;
  border: 1px solid #b3b3b3;
  transition: all 0.3s ease-in-out;

}

.dashboard-access-button >>> .nav-item{
  background: #ffffff;
  padding: 10px 20px;
}


</style>